export const campaignReviewDates: Record<string, string> = {
  "rakuten-iphone-17e": "2026.10.05",
  "rakuten-iphone-18-pro": "2026.10.05",
  "sim-only-mnp-campaigns": "2026.10.05",
  "ymobile-guide": "2026.10.05",
  "ahamo-guide": "2026.10.05",
  "rakuten-guide": "2026.10.05",
  "uqmobile-guide": "2026.10.05",
  "iijmio-guide": "2026.10.05",
  "which-plan-is-cheapest": "2026.10.05",
};
